import React from 'react';
import { Button, Dropdown, Tag } from 'antd';
import { MoreOutlined } from '@ant-design/icons';

const mechanicStyles = {
  Gift: {
    border: '1px solid #D3ADF7',
    background: '#F9F0FF',
    color: '#531DAB',
  },
  'Discount + Gift': {
    border: '1px solid #FFBB96',
    background: '#FFF2E8',
    color: '#D4380D',
  },
  'Discount + Gift': {
    border: '1px solid #FFBB96',
    background: '#FFF2E8',
    color: '#D4380D',
  },
  Discount: {
    border: '1px solid #FFE58F',
    background: '#FFFBE6',
    color: '#D48806',
  },
};



const formatDateDisplay = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

export const membershipColumns = (onAction) => [
  {
    title: 'Rule Name',
    dataIndex: 'ruleName',
    key: 'ruleName',
    width: 320,
    onHeaderCell: () => ({
      className: 'membership-rule-name-header',
    }),
    sorter: (a, b) => a.ruleName.localeCompare(b.ruleName),
    render: (text, record) => (
      <div
        onClick={() => onAction?.('view', record)}
        style={{ cursor: 'pointer' }}
      >
        <div style={{ fontWeight: 600, color: '#1f2937' }}>{text}</div>
        <div style={{ color: '#3b82f6', fontSize: 12 }}>{record.description}</div>
      </div>
    ),
  },
  {
    title: 'Customer Group',
    dataIndex: 'customerGroup',
    key: 'customerGroup',
    width: 130,
    render: (value) => (
      <span style={{ textTransform: 'capitalize' }}>{value}</span>
    ),
  },
  {
    title: 'Mechanic',
    dataIndex: 'mechanic',
    key: 'mechanic',
    width: 150,
    render: (value) => {
      const normalizedMechanic = String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[_-]+/g, ' ')
        .replace(/\s*\+\s*/g, ' + ')
        .replace(/\s+/g, ' ');
      const mechanicLabels = {
        gift: 'Gift',
        discount: 'Discount',
        'gift discount': 'Discount + Gift',
        'discount gift': 'Discount + Gift',
        'gift + discount': 'Discount + Gift',
        'discount + gift': 'Discount + Gift',
        'gift and discount': 'Discount + Gift',
        'discount and gift': 'Discount + Gift',
      };
      const displayValue = mechanicLabels[normalizedMechanic] || value;
      const style = {
        borderRadius: '4px',
        border: mechanicStyles[displayValue]?.border || 'var(--Components-Tag-Global-lineWidth, 1px) solid transparent',
        background: mechanicStyles[displayValue]?.background || 'transparent',
        color: mechanicStyles[displayValue]?.color || '#1f2937',
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '20px',
        padding: '1px 8px',
      };

      return (
        <Tag style={{ ...style, textTransform: 'capitalize' }}>{displayValue}</Tag>
      );
    },
  },
  {
    title: 'Area',
    dataIndex: 'area',
    key: 'area',
    width: 70,
    render: (value) => {
      const normalizedArea = String(value || '').trim().toLowerCase().replace(/[_-]+/g, ' ');
      const areaLabels = {
        bau: 'BAU',
        'lifecycle triggered': 'Lifecycle Triggered',
      };
      return <span>{areaLabels[normalizedArea] || value}</span>;
    },
  },
  {
    title: 'Store',
    dataIndex: 'store',
    key: 'store',
    width: 70,
  },
  {
    title: 'Priority',
    dataIndex: 'priority',
    key: 'priority',
    width: 80,
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    width: 90,
    render: (value) => {
      const dotColor = {
        active: '#52C41A',
        draft: 'rgba(0,0,0,.25)',
        paused: '#FAAD14',
        archived: '#FF4D4F',
      }[String(value || '').toLowerCase()] || '#999';

      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontWeight: 500, color: '#1f2937' }}>
          <span
            style={{
              width: 10,
              height: 10,
              borderRadius: '50%',
              backgroundColor: dotColor,
              display: 'inline-block',
              boxShadow: '0 0 0 2px rgba(0,0,0,0.04)',
            }}
          />
          <span style={{ textTransform: 'capitalize' }}>{value}</span>
        </div>
      );
    },
  },
  {
    title: 'Start',
    dataIndex: 'start',
    key: 'start',
    width: 110,
    render: (value) => <span title={value || ''}>{formatDateDisplay(value)}</span>,
  },
  {
    title: 'End',
    dataIndex: 'end',
    key: 'end',
    width: 110,
    render: (value) => <span title={value || ''}>{formatDateDisplay(value)}</span>,
  },
  {
    title: 'Uses',
    dataIndex: 'uses',
    key: 'uses',
    width: 65,
  },
  {
    title: 'Updated',
    dataIndex: 'updated',
    key: 'updated',
    width: 110,
    render: (value) => <span title={value || ''}>{formatDateDisplay(value)}</span>,
  },
  {
    title: 'Actions',
    key: 'actions',
    width: 80,
    render: (_, record) => {
      const status = String(record.status || '').toLowerCase();
      const isActive = status === 'active';

      return (
        <Dropdown
          trigger={['click']}
          className='membership-rule-actions-dropdown'
          placement="bottomRight"
          menu={{
            className: 'membership-rule-actions-dropdown-menu',
            // Let the table handle navigation and draft-copy behavior for this row.
            onClick: ({ key }) => onAction?.(key, record),
            items: [
              { key: 'view', label: 'View' },
              { key: 'edit', label: 'Edit' },
              ...(status !== 'draft' ? [{ key: 'draft', label: 'Draft' }] : []),
              { key: 'duplicate', label: 'Duplicate' },
              { key: isActive ? 'pause' : 'Active', label: isActive ? 'Pause' : 'Active' },
              ...(status !== 'archived' ? [{ key: 'archive', label: 'Archive' }] : []),
              // { key: 'delete', label: 'Delete' },
            ],
          }}
        >
        <Button
          type="text"
          icon={<MoreOutlined />}
          className='membership-rule-actions-dropdown-button'
        />
        </Dropdown>
      );
    },
  },
];

export default membershipColumns;
